import { el, setAttr } from 'https://cdn.venturz.co/lib/redom.es.js';

import {
  applyTraits
} from '/programs/utilities/language.js';

import { InputValueGetter, InputValueSetter } from '../traits/value-accessors.js';

class NumberInputRenderer {

  constructor() {

    this.input = null;

    this.el = el('.form-editor-number-input-renderer', [
      this.renderInput()
    ]);

  }

  renderInput() {

    this.input = el('input', {
      type: 'number'
    });

    return this.input;

  }

  update(options, fieldRow) {

    const attributes = {
      required: options.required,
      placeholder: options.placeholder || '',
      name: fieldRow.label
    };

    if (typeof options.min === 'number') {
      attributes.min = options.min;
    }

    if (typeof options.max === 'number') {
      attributes.max = options.max;
    }

    setAttr(this.input, attributes);

  }

}

export default applyTraits(NumberInputRenderer, [InputValueGetter, InputValueSetter]);
